var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerForeground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spiner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M14.7527 8C15.4416 8 16.0099 7.43826 15.903 6.75777C15.805 6.1347 15.6335 5.52394 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.4761 0.36648 9.8653 0.194973 9.24223 0.0970342C8.56174 -0.00992957 8 0.558421 8 1.24727C8 1.93611 8.56539 2.48049 9.23663 2.63522C9.53322 2.70358 9.82433 2.79659 10.1068 2.91361C10.7748 3.19029 11.3817 3.59582 11.893 4.10705C12.4042 4.61828 12.8097 5.2252 13.0864 5.89315C13.2034 6.17567 13.2964 6.46678 13.3648 6.76337C13.5195 7.43461 14.0639 8 14.7527 8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerForeground);
export default __webpack_public_path__ + "static/media/SpinnerForeground.5e2b8c537cd54dba0f2903c492ef221e.svg";
export { ForwardRef as ReactComponent };